import type { ReactElement } from 'react';
import { useEffect, useRef } from 'react';
import styles from './PluginErrorScreen.module.css';

export interface PluginErrorScreenProps {
  /** CA-16: distingue a mensagem final de falha de rede pura ("Sem conexão.
   * Verifique a rede.") da mensagem genérica de qualquer outra falha
   * (Design > Estado "Erro final"). */
  offline: boolean;
  onRetry: () => void;
}

/**
 * Estado 4 do Design da spec ("Erro final") — HUB-237, CA-10/CA-16.
 * Reusado tanto pelo esgotamento de tentativas na resolução do registro
 * (`usePluginRegistryResolution`) quanto no carregamento via Module
 * Federation (`usePluginLoadRetry`), que compartilham a mesma tela.
 */
export function PluginErrorScreen({ offline, onRetry }: PluginErrorScreenProps): ReactElement {
  const retryButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    retryButtonRef.current?.focus();
  }, []);

  return (
    <main className={styles.container} aria-label="Falha ao carregar ativação" role="main">
      <div className={styles.card} role="alert">
        <span className={styles.errorIcon} aria-hidden="true">
          ⛔
        </span>
        <h2 className={styles.heading}>Não foi possível carregar</h2>
        <p className={styles.message}>
          {offline ? 'Sem conexão. Verifique a rede.' : 'Verifique sua conexão e tente novamente.'}
        </p>
        <button
          ref={retryButtonRef}
          type="button"
          className={styles.retryButton}
          onClick={onRetry}
        >
          Tentar Novamente
        </button>
      </div>
    </main>
  );
}
